import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@/lib/api-client";

import type { NotificationStatus } from "@/types/notification";

export type UpdateNotificationStatusInput = {
  id: string;
  status: NotificationStatus;
};

export const updateNotificationStatus = async ({ id, status }: UpdateNotificationStatusInput) => {
  return api.put(`/carburate/notifications/messages/${id}/`, { status });
};

export const useUpdateNotificationStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateNotificationStatus,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["notifications"] }),
        queryClient.invalidateQueries({ queryKey: ["notifications-count"] }),
        queryClient.invalidateQueries({ queryKey: ["notifications-counts"] }),
      ]);
    },
  });
};
